module.exports = __webpack_public_path__ + "img/大气环境监测预警平台.f12235f6.png";